import PARTICIPANT_STATUS from "enums/PARTICIPANT_STATUS";

export const COMPLETED_STATUSES = [
  PARTICIPANT_STATUS.COMPLETED,
  PARTICIPANT_STATUS.PAID,
];
